import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const ONCELIK_RENK: Record<string, string> = { 'Düşük': '#94a3b8', 'Normal': '#3b82f6', 'Yüksek': '#f59e0b', 'Acil': '#ef4444' };
const ONCELIK_RGB: Record<string, string> = { 'Düşük': '148,163,184', 'Normal': '59,130,246', 'Yüksek': '245,158,11', 'Acil': '239,68,68' };

@Component({
  selector: 'gorev-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--gorev-ck" [style.--accent]="oncelikRenk()" [style.--accent-rgb]="oncelikRgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:8s;--x:20%;--y:30%"></span><span class="gc-p" style="--d:10s;--x:70%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:6s;--x:50%;--y:65%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">GÖREV</div>
        <div class="gv-ust">
          <div class="gv-check" [class.gv-check--tamam]="p()?.tamamlandi">{{ p()?.tamamlandi ? '✓' : '' }}</div>
          <div class="gv-ad gc-baslik-ana">{{ p()?.gorevAdi || 'Görev' }}</div>
        </div>
        @if (p()?.atanan) { <div class="gv-atanan"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>{{ p().atanan }}</div> }
        <div class="gv-alt">
          @if (p()?.oncelik) { <span class="gv-oncelik">{{ p().oncelik }}</span> }
          @if (p()?.tahminiSure) { <span class="gv-sure">{{ p().tahminiSure }}</span> }
        </div>
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? (p()?.tamamlandi ? 100 : 30) : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #10b981; --accent-rgb: 16,185,129; }
    .gv-ust { display: flex; align-items: center; gap: 8px; }
    .gv-check { width: 18px; height: 18px; border-radius: 3px; border: 2px solid var(--accent); display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 900; color: var(--accent); flex-shrink: 0; transition: all .2s; }
    .gv-check--tamam { background: var(--accent); color: #fff; }
    .gv-ad { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .gv-atanan { display: flex; align-items: center; gap: 4px; font-size: 10px; color: var(--py-metin-ikincil, #64748b); }
    .gv-atanan svg { color: var(--accent); opacity: .5; }
    .gv-alt { display: flex; gap: 8px; align-items: center; }
    .gv-oncelik { font-size: 8px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; padding: 2px 8px; border-radius: 2px; color: #fff; background: var(--accent); }
    .gv-sure { font-size: 9px; color: var(--py-metin-ikincil, #64748b); font-variant-numeric: tabular-nums; }
  `],
})
export class GorevKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  oncelikRenk = computed(() => ONCELIK_RENK[this.p()?.oncelik] || '#10b981');
  oncelikRgb = computed(() => ONCELIK_RGB[this.p()?.oncelik] || '16,185,129');
}
